import { Link } from "react-router-dom";
import { useStateContext } from "../../Contexts/ContextProvider";
const SliderRow = ({ slider  }) => {

  return (
    <>
      <tr>
    
        <td>
           
              <h6 className="mb-0 text-sm">{slider.title  } </h6>
        </td>

        <td>
        <h6 className="mb-0 text-sm">{slider.title  } </h6>
        </td>
        
      
        <td className="align-middle">
          <Link to={`./${slider.id}`}className="btn btn-dark">
            View Slider
          </Link>
        </td>
      </tr>
    </>
  )
}

export default SliderRow; 